module.exports = __webpack_public_path__ + "media/images/logo-weo-alt-4a8c89d21a24da2e918d88b931b8bc7c.png";